import {
  Box,
  Card,
  CardActionArea,
  CardContent,
  CardMedia,
  Grid,
  Rating,
  Stack,
  Typography,
} from "@mui/material";
import { t } from "i18next";
import moment from "moment";
import GlobalButton from "../button";
import Label from "../label";
import ReviewBox from "../reviewBox";
import { useSelector } from "react-redux";

const CompanyDetailCard = ({
  handleBookNow,
  detail,
  workerDetail,
  serviceDetail,
  handleChatNow,
  chatLoading,
}) => {
  const { currentLanguage } = useSelector((state) => state.translationReducer);

  return (
    <Grid
      container
      spacing={2}
      sx={{
        borderRadius: 2.5,
        padding: { xs: 1, sm: 2 },
        border: "1px solid #f5f5f5",
        backgroundColor: "text.white",
        boxShadow:
          "0px 0px 5px rgba(0, 0, 0, 0.1), 0px 0px 1px rgba(0, 0, 0, 0.1)",
      }}
    >
      {/* Worker Details */}
      <Grid item xs={12} md={4}>
        <Typography
          variant="h6"
          fontWeight={600}
          gutterBottom
          textTransform={"capitalize"}
        >
          {t("workerDetails")}
        </Typography>
        <Box
          width={"100%"}
          height={230}
          borderRadius={"12px"}
          display={"flex"}
          justifyContent={"center"}
          alignItems={"center"}
          sx={{
            background: "linear-gradient(135deg, #9700e1, #ceaffff5)",
          }}
        >
          <CardMedia
            component="img"
            image={workerDetail?.profileImg}
            sx={{
              height: { xs: "160px", md: "160px" },
              width: { xs: "160px", md: "160px" },
              borderRadius: "50%",
              flexShrink: 0,
            }}
          />
        </Box>
        <Stack gap={1} mt={2}>
          <GlobalButton btnText={"bookNow"} handleClickBtn={handleBookNow} />
          {/* <GlobalButton
            btnText={"Chat Now"}
            handleClickBtn={handleChatNow}
            disabled={chatLoading}
            startIcon={
              chatLoading && (
                <CircularProgress
                  size={"1rem"}
                  sx={{
                    "& .MuiCircularProgress-svg": {
                      color: "white",
                    },
                  }}
                />
              )
            }
          /> */}

          <Box p={1} borderRadius={2} bgcolor={"#f3f3f3"}>
            <Label text={t("joinedAt")} />
            <Typography variant="body1">
              {moment(workerDetail?.createdAt).format("MM/DD/YYYY")}
            </Typography>
          </Box>
          {/* <Box p={1} borderRadius={2} bgcolor={"#f3f3f3"}>
            <Label text={"Associated Company"} />
            <Typography variant="body1">{detail?.name}</Typography>
          </Box> */}
          <Box p={1} borderRadius={2} bgcolor={"#f3f3f3"}>
            <Label text={t("rating")} />
            <Stack direction={"row"} alignItems={"center"} gap={1}>
              <Rating
                precision={0.5}
                value={workerDetail?.rating || 1}
                readOnly
                size="small"
              />
              <Typography variant="body2" color={"text.slateGray"}>
                {workerDetail?.rating || 1}/5 Ratings (
                {workerDetail?.reviews?.length || 0} {t("reviews")})
              </Typography>
            </Stack>
          </Box>
        </Stack>
      </Grid>

      {/* Main Content */}
      <Grid item xs={12} md={8}>
        <CardContent sx={{ mt: 2.5 }}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Box p={1} borderRadius={2} bgcolor={"#f3f3f3"}>
                <Label text={t("fullName")} />
                <Typography variant="body1">{workerDetail?.name}</Typography>
              </Box>
            </Grid>
            {/* <Grid item xs={12} md={6}>
              <Box p={1} borderRadius={2} bgcolor={"#f3f3f3"}>
                <Label text={"Email"} />
                <Typography variant="body1">{workerDetail?.email}</Typography>
              </Box>
            </Grid>
            <Grid item xs={12} md={6}>
              <Box p={1} borderRadius={2} bgcolor={"#f3f3f3"}>
                <Label text={"Contact"} />
                <Typography variant="body1">{workerDetail?.contact}</Typography>
              </Box>
            </Grid> */}
            <Grid item xs={12} md={6}>
              <Box p={1} borderRadius={2} bgcolor={"#f3f3f3"}>
                <Label text={t("gender")} />
                <Typography variant="body1">{workerDetail?.gender}</Typography>
              </Box>
            </Grid>
            <Grid item xs={12} md={6}>
              <Box p={1} borderRadius={2} bgcolor={"#f3f3f3"}>
                <Label text={t("expertise")} />
                <Typography variant="body1">
                  {workerDetail?.expertise}
                </Typography>
              </Box>
            </Grid>
            {/* <Grid item xs={12}>
              <Box p={1} borderRadius={2} bgcolor={"#f3f3f3"}>
                <Label text={"Address"} />
                <Typography variant="body1">
                  {workerDetail?.location?.addressLable}
                </Typography>
              </Box>
            </Grid> */}
            <Grid item xs={12}>
              <Box p={1} borderRadius={2} bgcolor={"#f3f3f3"}>
                <Label text={t("bio")} />
                <Typography variant="body1">
                  {workerDetail?.bio || `${t("bioDescription")}.`}
                </Typography>
              </Box>
            </Grid>
          </Grid>
        </CardContent>
      </Grid>

      <Grid item xs={12} md={12}>
        <Typography
          variant="h6"
          fontWeight={600}
          gutterBottom
          textTransform={"capitalize"}
        >
          {t("selectedService")}
        </Typography>
        <Stack
          direction={{ md: "row" }}
          spacing={2}
          alignItems="center"
          overFlow={"hidden"}
          sx={{
            padding: 2,
            border: "1px solid #d9d3d3",
            borderRadius: 2,
            backgroundColor: "#f9f9f9",
          }}
        >
          <CardMedia
            component="img"
            image={serviceDetail?.serviceSubCategoryId?.image}
            sx={{
              height: { xs: "100%", md: "160px" },
              width: { xs: "100%", md: "160px" },
              borderRadius: "8px",
              flexShrink: 0,
            }}
          />
          <Box overflow={"hidden"}>
            <Typography
              variant="h6"
              fontWeight={600}
              textTransform={"capitalize"}
            >
              {serviceDetail?.serviceSubCategoryId?.name[currentLanguage]}
            </Typography>
            <Typography
              variant="body2"
              color="text.mediumGray"
              sx={{ lineHeight: 1.5, mt: 1 }}
              // noWrap
            >
              {
                serviceDetail?.serviceSubCategoryId?.description[
                  currentLanguage
                ]
              }
            </Typography>

            {serviceDetail?.serviceSubCategoryId?.type === "fixed" && (
              <Typography
                variant="body2"
                color="text.mediumGray"
                fontWeight={600}
                mt={1}
                textTransform={"capitalize"}
              >
                {t("serviceCharges")}: {serviceDetail?.price?.fixed || 0}
              </Typography>
            )}
            {serviceDetail?.serviceSubCategoryId?.type === "area" && (
              <Typography
                variant="body2"
                color="text.mediumGray"
                fontWeight={600}
                mt={1}
                textTransform={"capitalize"}
              >
                {t("perAreaCharges")}: {serviceDetail?.price?.area || 0}
              </Typography>
            )}

            {serviceDetail?.serviceSubCategoryId?.type === "room+area" && (
              <Typography
                variant="body2"
                color="text.mediumGray"
                fontWeight={600}
                mt={1}
                textTransform={"capitalize"}
              >
                {t("perAreaCharges")}: {serviceDetail?.price?.area || 0} <br />
                {t("perRoomCharges")}: {serviceDetail?.price?.room || 0}
              </Typography>
            )}
            {serviceDetail?.serviceSubCategoryId?.type ===
              "interior+exterior" && (
              <Typography
                variant="body2"
                color="text.mediumGray"
                fontWeight={600}
                mt={1}
                textTransform={"capitalize"}
              >
                {t("interior")} {t("charges")}:{" "}
                {serviceDetail?.price?.interior || 0} <br />
                {t("exterior")} {t("charges")}:{" "}
                {serviceDetail?.price?.exterior || 0}
              </Typography>
            )}
          </Box>
        </Stack>
      </Grid>

      {/* Other services offers */}

      <Grid item xs={12} mt={2}>
        <Typography
          variant="h6"
          fontWeight={600}
          gutterBottom
          textTransform={"capitalize"}
        >
          {t("otherServicesOffer")}
        </Typography>
        <Grid container spacing={2} alignItems={"stretch"}>
          {workerDetail?.services?.map((val) =>
            val?.subServices?.map((x) => {
              if (x._id !== serviceDetail?.serviceSubCategoryId?._id) {
                return (
                  <Grid item xs={12} sm={6} md={4} key={x._id} display={"flex"}>
                    <Card sx={{ maxWidth: 345 }}>
                      <CardActionArea>
                        <CardMedia
                          component="img"
                          height="160"
                          image={x.image}
                          alt={x.name[currentLanguage]}
                        />
                        <CardContent>
                          <Typography
                            textTransform={"capitalize"}
                            gutterBottom
                            variant="h6"
                            component="div"
                          >
                            {x.name[currentLanguage]}
                          </Typography>
                          <Typography
                            variant="body2"
                            sx={{ color: "text.secondary" }}
                          >
                            {x.description[currentLanguage]}
                          </Typography>
                        </CardContent>
                      </CardActionArea>
                    </Card>
                  </Grid>
                );
              }
              return null; // Avoid returning undefined
            })
          )}
        </Grid>
      </Grid>

      <Grid item xs={12} display={"flex"} justifyContent={"flex-end"}>
        <GlobalButton
          btnText={"bookNow"}
          handleClickBtn={handleBookNow}
          styleProps={{
            width: { xs: "100%", md: "150px" },
          }}
        />
      </Grid>

      <Grid item xs={12} mt={2}>
        <Typography
          variant="h6"
          fontWeight={600}
          gutterBottom
          textTransform={"capitalize"}
        >
          {t("workerReviews")}
        </Typography>
        <Box paddingY={5}>
          {workerDetail?.reviews?.length > 0 ? (
            <ReviewBox data={workerDetail?.reviews} />
          ) : (
            <Typography
              variant="h5"
              textAlign={"center"}
              my={3}
              fontWeight={600}
            >
              {t("noReviews")} !
            </Typography>
          )}
        </Box>
      </Grid>
    </Grid>
  );
};

export default CompanyDetailCard;

// export default CompanyDetailCard;
